var _mask, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_1518_25285",
    maskUnits: "userSpaceOnUse",
    x: 0.5,
    y: 0,
    width: 36,
    height: 36,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.5,
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18C2.5 9.16344 9.66344 2 18.5 2C27.3366 2 34.5 9.16344 34.5 18C34.5 26.8366 27.3366 34 18.5 34C9.66344 34 2.5 26.8366 2.5 18Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18C2.5 9.16344 9.66344 2 18.5 2C27.3366 2 34.5 9.16344 34.5 18C34.5 26.8366 27.3366 34 18.5 34C9.66344 34 2.5 26.8366 2.5 18Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 32C10.768 32 4.5 25.732 4.5 18H0.5C0.5 27.9411 8.55888 36 18.5 36V32ZM32.5 18C32.5 25.732 26.232 32 18.5 32V36C28.4411 36 36.5 27.9411 36.5 18H32.5ZM18.5 4C26.232 4 32.5 10.268 32.5 18H36.5C36.5 8.05888 28.4411 0 18.5 0V4ZM18.5 0C8.55888 0 0.5 8.05888 0.5 18H4.5C4.5 10.268 10.768 4 18.5 4V0Z",
    fill: "white",
    mask: "url(#path-1-outside-1_1518_25285)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11.334C16.7534 11.334 15.3334 12.754 15.3334 14.5007C15.3334 16.214 16.6734 17.6007 18.42 17.6607C18.4734 17.654 18.5267 17.654 18.5667 17.6607C18.58 17.6607 18.5867 17.6607 18.6 17.6607C18.6067 17.6607 18.6067 17.6607 18.6134 17.6607C20.32 17.6007 21.66 16.214 21.6667 14.5007C21.6667 12.754 20.2467 11.334 18.5 11.334Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8866 19.4339C20.0266 18.1939 16.9933 18.1939 15.12 19.4339C14.2733 20.0006 13.8066 20.7672 13.8066 21.5872C13.8066 22.4072 14.2733 23.1672 15.1133 23.7272C16.0466 24.3539 17.2733 24.6672 18.5 24.6672C19.7266 24.6672 20.9533 24.3539 21.8866 23.7272C22.7266 23.1606 23.1933 22.4006 23.1933 21.5739C23.1866 20.7539 22.7266 19.9939 21.8866 19.4339Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFilled);
export default __webpack_public_path__ + "static/media/profile-filled.06339a3aec01025fc39e65c4c9e6e44c.svg";
export { ForwardRef as ReactComponent };